/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import apiClient from './client';
export const sessioniAPI = {
  attiva: async () => { const { data } = await apiClient.get('/sessioni/attiva'); return data; },
  // intervento_id opzionale: se omesso avvia una sessione "libera" non ancora assegnata
  start: async (intervento_id) => {
    const body = intervento_id ? { intervento_id } : {};
    const { data } = await apiClient.post('/sessioni/start', body);
    return data;
  },
  stop: async (sessione_id, { note, pausa_minuti, fine, dichiarazione, dichiarazione_accettata, cliente_id, titolo, descrizione, interno, categoria_interna }) => {
    const body = { sessione_id, note, pausa_minuti, dichiarazione, dichiarazione_accettata };
    if (fine) body.fine = fine;
    // Sessione libera assegnata a un cliente: crea un nuovo intervento
    if (cliente_id) { body.cliente_id = cliente_id; body.titolo = titolo; if (descrizione) body.descrizione = descrizione; }
    // Sessione libera come lavoro interno (non per un cliente)
    if (interno) { body.interno = true; body.categoria_interna = categoria_interna; body.titolo = titolo; }
    const { data } = await apiClient.post('/sessioni/stop', body);
    return data;
  },
  // Scarta un timer avviato per errore: la sessione viene eliminata e le ore non contano
  annulla: async (sessione_id, motivo) => {
    const { data } = await apiClient.post('/sessioni/annulla', { sessione_id, motivo: motivo || null });
    return data;
  },
};
